function getQuickSearch(key: string): unknown {
  if (typeof window !== 'undefined') {
    const storedQuickSearch = localStorage.getItem(key);
    if (storedQuickSearch) {
      try {
        const parsedQuickSearch = JSON.parse(storedQuickSearch);
        return parsedQuickSearch;
      } catch (error) {
        console.error("Invalid JSON in localStorage for 'quickSearch':", error);
      }
    }
  }
};

export default getQuickSearch;